document.addEventListener('alpine:init', () => {
  Alpine.store('wishlist_count', {
    count: 0,
    init() {
      // Initialize the count when the store is created
      this._updateCount();

      // Set up periodic checking for wishlist updates
      setInterval(() => {
        this._updateCount();
      }, 1000);
    },
    _updateCount() {
      const wishlistPageEl = document.querySelector('wishlist-page');
      if (wishlistPageEl && wishlistPageEl.wishlist && wishlistPageEl.wishlist.numItems !== undefined) {
        this.count = wishlistPageEl.wishlist.numItems;
      }
    }
  });
});
